export enum OverlayDialogDevice {
    Mobile = 'Mobile',
    Tablet = 'Tablet',
    Desktop = 'Desktop'
}
